import React from "react";

import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";

import {
  ExceptionIcon,
  HashIcon,
  SealIcon,
  SignatureIcon,
} from "../../../components/common/iconography";
import { isAuthorized } from "../../../utils/appUtils";
import { AclType, CarrierType } from "../../../utils/constants";
import { shouldBlockSealActionForRailcarVerification } from "../../../utils/railCarUtils";
import { shouldBlockSealActionForContainerVerification } from "./placedShipmentValidation";

export const getInboundSpeedDialActions = ({
  inboundShipment,
  isContainerNumberValidated,
  shipmentRailcarVerificationState,
  onOpenExceptionDialog,
  onOpenChecklistDialog,
  onOpenSignaturesDialog,
  onOpenSealDialog,
  onOpenContainerNumberDialog,
  onOpenRailcarDialog,
  onSealBlocked,
  onSealBlockedByContainer,
}) => {
  const actionConfigs = [
    {
      condition: true,
      icon: <ExceptionIcon />,
      onClick: onOpenExceptionDialog,
      name: "Exceptions",
    },
    {
      condition: inboundShipment.checklist?.length > 0,
      icon: <CheckOutlinedIcon />,
      onClick: onOpenChecklistDialog,
      name: "Checklist",
    },
    {
      // Signatures are collected off the driver, so rail arrivals never show it.
      condition:
        inboundShipment.carrierType === CarrierType.TRUCK &&
        !inboundShipment.skipSignature &&
        isAuthorized(AclType.OUTBOUND_SIGN),
      icon: <SignatureIcon />,
      onClick: onOpenSignaturesDialog,
      name: "Signatures",
    },
    {
      condition: inboundShipment.account?.trackInboundSeals,
      icon: <SealIcon />,
      onClick: () => {
        if (
          shouldBlockSealActionForRailcarVerification({
            requiresVerification:
              shipmentRailcarVerificationState.requiresVerification,
            isRailcarValidated:
              shipmentRailcarVerificationState.isRailcarValidated,
          })
        ) {
          onOpenRailcarDialog();
          onSealBlocked();
          return;
        }

        if (
          shouldBlockSealActionForContainerVerification({
            containerDrop: inboundShipment.containerDrop,
            isContainerNumberValidated,
          })
        ) {
          onOpenContainerNumberDialog();
          onSealBlockedByContainer();
          return;
        }

        onOpenSealDialog();
      },
      name: "Seal",
    },
    {
      condition: inboundShipment.containerDrop && !isContainerNumberValidated,
      icon: <HashIcon />,
      onClick: onOpenContainerNumberDialog,
      name: "Container",
    },
    {
      condition: shipmentRailcarVerificationState.requiresVerification,
      icon: <HashIcon />,
      onClick: onOpenRailcarDialog,
      name: "Railcar",
    },
  ];

  return actionConfigs.filter((action) => action.condition);
};
